import { 
    FETCH_ALL_DOCUMENTS,
    FETCH_ALL_DOCUMENTS_SUCCESS,
    FETCH_ALL_DOCUMENTS_FAILED,
  } from "../actions/types";
  
  export const INITIAL_STATE = {
    documents:null,
    loading: false,
    error:{
      flag:false,
      msg: null
    }
  }
  
  export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case FETCH_ALL_DOCUMENTS:
        return {
          ...state,
          loading:true
        };
      case FETCH_ALL_DOCUMENTS_SUCCESS:
        return {
          ...state,
          documents:action.payload,
          loading:false
        };
      case FETCH_ALL_DOCUMENTS_FAILED:
        return {
          ...state,
          documents:null,
          loading:false,
          error:{
            flag:true,
            msg:action.payload
          }
        };
      default:
        return state;
    }
  };